import React from 'react';

const Social = () => (
  <div className="flex items-center justify-center mt-12">
    <a
      href="https://www.facebook.com/wearejoybird"
      target="_blank"
      rel="noopener noreferrer"
      title="Facebook"
      aria-label="Facebook"
      className="mx-5"
    >
      <svg
        width="25px"
        height="24px"
        viewBox="0 0 25 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <polygon points="0.3562 0 24.356 0 24.356 24 0.3562 24" />
        </defs>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Group-17">
            <path
              d="M23.0322,0 L1.6792,0 C0.9492,0 0.3562,0.593 0.3562,1.324 L0.3562,22.676 C0.3562,23.408 0.9492,24 1.6792,24 L13.1742,24 L13.1742,14.706 L10.0452,14.706 L10.0452,11.085 L13.1742,11.085 L13.1742,8.41 C13.1742,5.311 15.0682,3.625 17.8332,3.625 C19.1582,3.625 20.2972,3.722 20.6292,3.766 L20.6292,7.006 L18.7082,7.006 C17.2082,7.006 16.9162,7.727 16.9162,8.777 L16.9162,11.088 L20.5002,11.088 L20.0352,14.718 L16.9162,14.718 L16.9162,24 L23.0312,24 C23.7632,24 24.3562,23.408 24.3562,22.676 L24.3562,1.324 C24.3562,0.593 23.7632,0 23.0322,0"
              id="Fill-15"
              mask="url(#mask-2)"
              className="fill-brand"
            />
          </g>
        </g>
      </svg>
    </a>

    <a
      href="https://twitter.com/wearejoybird"
      target="_blank"
      title="Twitter"
      aria-label="Twitter"
      rel="noopener noreferrer"
      className="mx-5"
    >
      <svg
        width="25px"
        height="20px"
        viewBox="0 0 25 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <path
            d="M24.3096,2.5688 C23.4246,2.9578 22.4806,3.2228 21.4856,3.3438 C22.4986,2.7328 23.2796,1.7698 23.6486,0.6208 C22.6976,1.1758 21.6426,1.5798 20.5216,1.8048 C19.6246,0.8458 18.3476,0.2458 16.9296,0.2458 C14.2126,0.2458 12.0096,2.4488 12.0096,5.1628 C12.0096,5.5528 12.0546,5.9278 12.1366,6.2868 C8.0466,6.0938 4.4216,4.1298 1.9966,1.1608 C1.5696,1.8828 1.3306,2.7218 1.3306,3.6358 C1.3306,5.3458 2.2006,6.8488 3.5176,7.7318 C2.7106,7.7058 1.9526,7.4838 1.2896,7.1158 L1.2896,7.1768 C1.2896,9.5618 2.9836,11.5508 5.2366,12.0038 C4.8236,12.1148 4.3866,12.1748 3.9406,12.1748 C3.6256,12.1748 3.3256,12.1448 3.0246,12.0888 C3.6556,14.0418 5.4686,15.4658 7.6276,15.5058 C5.9486,16.8248 3.8196,17.6108 1.5266,17.6108 C1.1356,17.6108 0.7476,17.5878 0.3566,17.5438 C2.5446,18.9378 5.1236,19.7528 7.9136,19.7528 C16.9666,19.7528 21.9126,12.2568 21.9126,5.7668 C21.9126,5.5578 21.9126,5.3468 21.8976,5.1368 C22.8586,4.4478 23.6976,3.5768 24.3576,2.5888 L24.3096,2.5688 Z"
            id="Fill-13"
            className="fill-brand"
          />
        </g>
      </svg>
    </a>

    <a
      href="https://www.pinterest.com/joybird/"
      target="_blank"
      title="Pinterest"
      aria-label="Pinterest"
      rel="noopener noreferrer"
      className="mx-5"
    >
      <svg
        width="25px"
        height="24px"
        viewBox="0 0 25 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <path
            d="M12.5029,0 C5.8819,0 0.5149,5.367 0.5149,11.987 C0.5149,17.066 3.6729,21.404 8.1329,23.149 C8.0269,22.2 7.9339,20.746 8.1739,19.71 C8.3929,18.773 9.5799,13.753 9.5799,13.753 C9.5799,13.753 9.2209,13.033 9.2209,11.972 C9.2209,10.309 10.1879,9.061 11.3889,9.061 C12.4129,9.061 12.9059,9.83 12.9059,10.749 C12.9059,11.778 12.2539,13.316 11.9149,14.741 C11.6299,15.934 12.5149,16.906 13.6899,16.906 C15.8169,16.906 17.4579,14.661 17.4579,11.419 C17.4579,8.558 15.3949,6.55 12.4489,6.55 C9.0399,6.55 7.0409,9.112 7.0409,11.749 C7.0409,12.782 7.4349,13.892 7.9299,14.49 C8.0279,14.61 8.0419,14.715 8.0149,14.835 C7.9249,15.21 7.7219,16.034 7.6809,16.198 C7.6279,16.423 7.5089,16.469 7.2789,16.363 C5.7849,15.673 4.8469,13.485 4.8469,11.717 C4.8469,7.941 7.5949,4.465 12.7669,4.465 C16.9249,4.465 20.1589,7.432 20.1589,11.388 C20.1589,15.523 17.5519,18.85 13.9259,18.85 C12.7119,18.85 11.5709,18.221 11.1679,17.471 L10.4189,20.319 C10.1489,21.364 9.4149,22.671 8.9209,23.465 C10.0439,23.81 11.2269,24 12.4709,24 C19.0779,24 24.4559,18.635 24.4559,12.013 C24.4559,5.39 19.0779,0.026 12.4709,0.026 L12.5029,0 Z"
            id="Fill-11"
            className="fill-brand"
          />
        </g>
      </svg>
    </a>

    <a
      href="https://www.houzz.com/pro/wearejoybird/joybird-furniture"
      target="_blank"
      title="Houzz"
      aria-label="Houzz"
      rel="noopener noreferrer"
      className="mx-5"
    >
      <svg
        width="15px"
        height="24px"
        viewBox="0 0 15 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <polygon
            id="Fill-4"
            className="fill-brand"
            points="14.8018 12 14.8018 20 7.8708 24 7.8708 15.998 0.9418 20 0.9418 3.998 7.8708 0 7.8708 8 0.9438 12 7.8708 15.998 7.8708 8 14.8018 3.998"
          />
        </g>
      </svg>
    </a>
  </div>
);

export default Social;
